// services/adriver.js
// AdRiver Tracking Service

import { ANALYTICS_DISABLED } from '@/config/analytics';

/* eslint-disable no-undef, no-unused-vars */

class AdRiverService {
    constructor() {
        this.disabled = true;
        // Базовые параметры для всех счетчиков
        this.baseConfig = {
            sid: 233138,
            bt: 62
        };
    }

    debugLog() {
        // no-op
    }

    /**
     * Универсальная функция для отправки событий AdRiver
     * @param {string|null} eventType - Тип события (sz параметр)
     * @param {object} additionalParams - Дополнительные параметры отслеживания
     */
    track(eventType = null, additionalParams = {}) {
        if (this.disabled) {
            return;
        }
        if (ANALYTICS_DISABLED) {
            return;
        }
        // Проверяем доступность библиотеки AdRiver
        if (!window.adrCounterStorage) {
            this.debugLog('skip: adrCounterStorage is not available');
            // console.warn('AdRiver library not loaded. Make sure you have included the script in your HTML head.');
            return;
        }

        // Проверяем доступность конструктора AdriverCounterJS
        if (typeof AdriverCounterJS === 'undefined') {
            this.debugLog('skip: AdriverCounterJS is not available');
            // console.warn('AdriverCounterJS not available. Make sure AdRiver library is properly loaded.');
            return;
        }

        // Создаем конфигурацию счетчика
        const config = { ...this.baseConfig };

        // Добавляем тип события если указан
        if (eventType) {
            config.sz = eventType;
        }

        // Параметры отслеживания
        const trackingParams = {
            id: "",
            gid1: "",
            yid1: "",
            ...additionalParams
        };

        this.debugLog('queue event', {
            eventType: eventType || 'page_view',
            config,
            trackingParams
        });

        // Добавляем счетчик в очередь AdRiver
        window.adrCounterStorage.push(() => {
            new AdriverCounterJS(config, trackingParams);
            this.debugLog('sent event', {
                eventType: eventType || 'page_view',
                config,
                trackingParams
            });
        });

    }

    /**
     * Сквозной счетчик - отслеживание просмотров страниц
     */
    trackPageView() {
        this.track();
    }

    /**
     * Клик на кнопку перехода в Telegram-бот
     */
    trackTelegramBotClick() {
        this.track('click_na_knopky_pereiti_v_chat_bot');
    }

    /**
     * Клик на кнопку "Зарегистрировать чек"
     */
    trackRegisterReceiptClick() {
        this.track('click_na_knopky_zaregistrirovat_chek');
    }

    /**
     * Успешная загрузка чека
     */
    trackReceiptUploadSuccess() {
        this.track('yspeshnaya_registracia_cheka');
    }

    /**
     * Успешная регистрация пользователя
     */
    trackUserRegistrationSuccess() {
        this.track('yspeshnaya_registracia_polzovatelya');
    }

    /**
     * Универсальный метод для отслеживания пользовательских событий
     * @param {string} eventName - Название события
     * @param {object} userParams - Параметры пользователя (id, gid1, yid1)
     */
    trackCustomEvent(eventName, userParams = {}) {
        this.track(eventName, userParams);
    }

    /**
     * Проверка доступности AdRiver
     * @returns {boolean}
     */
    isAvailable() {
        if (this.disabled) {
            return false;
        }
        return typeof window !== 'undefined' &&
            !!window.adrCounterStorage &&
            typeof AdriverCounterJS !== 'undefined';
    }

    /**
     * Установка пользовательских параметров по умолчанию
     * @param {object} params - Параметры пользователя
     */
    setDefaultUserParams(params) {
        this.defaultUserParams = params;
    }

    // Legacy aliases for old calls in codebase.
    trackReceiptUpload() {
        this.trackReceiptUploadSuccess();
    }

    trackRegistration() {
        this.trackUserRegistrationSuccess();
    }
}

// Создаем единственный экземпляр сервиса (Singleton pattern)
const adRiverService = new AdRiverService();

// Экспортируем экземпляр
export default adRiverService;

// Также экспортируем класс на случай, если нужно создать несколько экземпляров
export { AdRiverService };
